








import {Component } from 'vue-property-decorator';
import KebabMenu from "@share/common/kebab-menu/KebabMenu.vue";
import CardEditButton from "@share/common/buttons/CardEditButton-01.vue";
import { MenuEvent } from "@api/enums/MenuEvents";
import Deletable from '@share/common/base/deletable/Deletable.vue';

@Component({
    components: { KebabMenu, CardEditButton }
})
export default class SessionCardEdit extends Deletable {
    async chooseHandler(eventName: MenuEvent) {
        if (eventName === MenuEvent.delete) {
            await this.delete(this.$t('agenda.deleteSessionConfirmTitle').toString())
        }
    }
}

